@charset "UTF-8";

/* src/app/modules/institutions/institutions-orders/institutions-orders.component.scss */
.cdk-table,
.mat-mdc-table {
  background: var(--color-default-light);
  width: 100%;
}
.cdk-header-row,
.mat-mdc-header-row {
  font: 700 1.3rem/44px Roboto;
  height: 44px;
  text-align: left;
  border-bottom-color: var(--color-accent);
}
.cdk-row,
.mat-mdc-row {
  border-bottom: 1px solid var(--color-primary-lighter);
  cursor: pointer;
  font: 400 1.3rem/44px Roboto;
  height: 44px;
  text-align: left;
  width: 100%;
}
.cdk-row:hover,
.mat-mdc-row:hover {
  background-color: var(--color-primary-light);
}
.cdk-row.selected,
.mat-mdc-row.selected {
  background-color: var(--color-primary-light);
}
.mat-mdc-header-cell,
.mat-mdc-cell {
  color: var(--color-default-dark);
  font-size: 13px;
  height: 44px;
  line-height: 1.8rem;
  max-height: 44px;
  max-width: 200px;
  min-width: 30px;
  overflow: hidden;
  padding-left: 10px;
  text-overflow: ellipsis;
  vertical-align: middle;
  white-space: nowrap;
}
.mat-mdc-header-cell {
  border-bottom: none;
  font-weight: 700;
}
.mat-mdc-header-cell:after {
  border-bottom: 5px solid var(--color-accent);
  bottom: 0;
  content: "";
  left: 0;
  position: absolute;
  width: 100%;
}
.mat-mdc-input-element:disabled {
  color: rgb(0, 0, 0);
}
:host ::ng-deep .mat-form-field-disabled .mat-form-field-underline {
  background-image: none !important;
  color: rgb(0, 0, 0);
}
table {
  float: right;
  width: 200px;
}
.input-field {
  text-align: right;
  width: 200px;
}
.clear {
  clear: both;
  height: 0;
  line-height: 0;
  font-size: 0;
}
/*# sourceMappingURL=institutions-orders.component.css.map */
